const steps = {
	stepProject: {
		title: 'Informations sur le Projet',
		platformType: 'Type de plateforme',
		tourism: 'Tourisme',
		pms: 'Multiservices',
		nomProjet: 'Nom du projet *',
		nomPass: 'Nom du Pass *',
		territoire: 'Territoire *',
		helpNomProjet: 'Dénomination du projet en minuscules sans accent, ni espace, ni caractère spécial (tiret autorisé)',
		helpNomPass: "Dénomination officielle de l'offre",
		helpTerritoire: 'Zone géographique',
		phNom: 'Exemple : sete',
		phPass: 'Exemple : SAM Pass',
		phTerr: 'Exemple : Sète agglomération',
	},
	stepIssuer: {
		title: "Informations sur l'Émetteur",
		nom: "Nom complet de l'émetteur *",
		helpNom: "Nom complet de l'émetteur (personne morale)",
		ref: 'Référence *',
		helpRef: 'Abrégé en majuscules',
		adresse: 'Adresse postale publique *',
		helpAdresse: "Si plusieurs lignes d'adresse, les séparer par une virgule",
		cp: 'Code postal *',
		ville: 'Ville *',
		pays: 'Pays *',
		paysAutrePh: 'Précisez le pays',
		tel: 'Téléphone public :',
		helpTel: "Ligne publique de l'émetteur",
		site: 'Site institutionnel public *',
		helpSite: "Site Web de l'émetteur",
		domaine: 'Domaine *',
		emailBlock: 'Adresses email',
		emailPublic: 'Email public de contact *',
		emailNotif: 'Email de réception des notifications automatiques *',
		socialBlock: 'Réseaux sociaux',
		facebook: 'Facebook :',
		youtube: 'Youtube :',
		instagram: 'Instagram :',
		x: 'X :',
	},
	services: {
		title: 'Services',
		dechetterie: 'Déchetterie',
		piscine: 'Piscine/Centre sportif',
		mediatheque: 'Médiathèque',
		musee: 'Musée/Activité touristique',
		transport: 'Transport',
		autres: 'Autres :',
		transportOffer: "Le Pass est-il constitué d'une offre transport ?",
		operator: "Quel est l'opérateur de transport ?",
		operatorPh: "Précisez l'opérateur",
		durationQ: "L'offre transport comporte-elle des durées différentes ?",
		phService: 'Exemple : Parking',
	},
	tourist: {
		title: 'Données Touristiques',
		alim: "La plateforme doit-elle être alimentée par les données d'une base touristique ?",
		editor: "Quel est l'éditeur de la plateforme de données touristiques ?",
		editorPh: "Précisez l'éditeur",
		freq: 'Fréquence des synchronisations :',
		freqPh: 'Précisez la fréquence',
	},
	support: {
		visuelTitle: 'Visuel du Pass',
		visuelQ: 'Avez-vous déjà un visuel pour le Pass ?',
		chooseFile: 'Choisir un fichier',
		fileSelected: 'Fichier sélectionné :',
		altVisuel: 'Visuel du Pass',
		supDematTitle: 'Support Dématérialisé',
		supDematQ: 'Le Pass sera-t-il disponible en support dématérialisé ?',
		supPhysTitle: 'Support Physique',
		supPhysQ: 'Le Pass sera-t-il disponible en support physique ?',
		id1: 'Identifiants du Pass (recto) - identifiant 1',
		id1prec: "Précisez :",
		id1ph: "Précisez l'identifiant",
		id2: 'Identifiants du Pass (verso) - identifiant 2',
	},
	devices: {
		title: 'Dispositifs de Lecture',
		presta: 'Vos prestataires sont-ils déjà équipés de dispositifs de lecture ?',
		typeLecture: 'Type de lecture :',
		qr: 'QR Code',
	},
	website: {
		title: 'Site Web Dédié au Pass (Front)',
		ordered: 'Avez-vous commandé le Front Otipass ?',
		langs: 'Langues, traductions :',
		domainQ: 'Si vous avez déjà choisi un nom de domaine, quel est-il ?',
		bookQ: "L'avez-vous déjà réservé ?",
		operator: "Précisez l'opérateur",
		phOp: 'Exemple : Gandi, OVH',
	},
	social: {
		title: 'Réseaux Sociaux dédiés au Pass',
		fb: 'Page Facebook :',
		yt: 'Youtube :',
		ig: 'Instagram :',
		x: 'X :',
	},
	subscriptions: {
		title: 'Inscriptions & Boutique en ligne',
		passGratuit: 'Distribuez-vous un Pass gratuit ?',
		insBlock: 'Inscriptions en Ligne (Pass gratuit)',
		existingForm: "Existe-t-il déjà un formulaire en ligne pour l'inscription des nouveaux usagers ?",
		urlForm: "Quelle est son URL ?",
		otipassForm: "Prévoyez-vous d'activer le formulaire d'inscription en ligne Otipass ?",
		otipassFeat: "Fonctionnalités formulaire d'inscription Otipass",
		pjTypes: 'Types de pièces justificatives demandées',
		pjOtherPh: 'Précisez une autre pièce justificative',
		passPayant: 'Distribuez-vous un Pass payant ?',
		boutiqueBlock: 'Boutique en ligne (Pass payant)',
		existingShop: "Existe-t-il déjà une boutique pour la vente du Pass en ligne ?",
		editorShop: "Quel est l'éditeur de la boutique existante ?",
		urlShop: "Quelle est son URL ?",
		otipassShop: "Prévoyez-vous d'activer la boutique en ligne Otipass ?",
		otipassShopFeat: 'Fonctionnalités boutique Otipass',
		conditions: 'Précisez les conditions',
		paymentGws: 'Passerelles de paiement',
		gwOther: 'Précisez la passerelle de paiement',
		userData: 'Données utilisateurs récoltées',
		uid: 'Identifiant à usage unique (UID) — choisir les champs',
		obligatoire: 'obligatoire',
	},
	finance: {
		title: 'Gestion financière',
		currencies: 'Devises',
		periodEntrees: 'Périodicité des états sur les entrées',
		periodVentes: 'Périodicité des états sur les ventes',
	},
	various: {
		title: 'Langues, couleurs et Divers',
		backLangs: 'Langues, traductions disponibles sur le Back-Office :',
		primary: 'Couleur primaire dominante :',
		secondary: 'Couleur secondaire :',
		mobile: "Avez-vous commandé l'application mobile bénéficiaire ?",
		phColor: 'Exemple : #0090AA',
		phColor2: 'Exemple : #FF6600',
	},
	contacts: {
		title: 'Contacts',
		tabCoord: 'Coordinateur',
		tabCoordDesc: 'Coordinateur.trice du projet',
		tabTech: 'Technique',
		tabTechDesc: 'Contact technique intégration Web',
		tabData: 'Données touristiques',
		tabDataDesc: 'Contact intégration données touristiques (Apidae, Tourinsoft)',
		tabCompta: 'Comptabilité',
		tabComptaDesc: 'Référent.e comptabilité',
		tabAutre: '•••',
		tabAutreDesc: 'Autre / Préciser',
		lastname: 'Nom',
		firstname: 'Prénom',
		email: 'Adresse email',
		tel1: 'Tél. 1',
		tel2: 'Tél. 2',
		function: 'Fonction',
	},
	formulas: {
		title: 'Formules',
		add: 'Ajouter une formule',
	},
};

export default steps;
